/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statistics_Day_5Inputs */

const he_statistics_day_5 = /** @type {(inputs: Statistics_Day_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שישי`)
};

const en_statistics_day_5 = /** @type {(inputs: Statistics_Day_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Friday`)
};

/**
* | output |
* | --- |
* | "Friday" |
*
* @param {Statistics_Day_5Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const statistics_day_5 = /** @type {((inputs?: Statistics_Day_5Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statistics_Day_5Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_statistics_day_5(inputs)
	return en_statistics_day_5(inputs)
});